<template>
  <section>
    <!-- start of sidebar -->
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item :to="item.link">
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.link"
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
    <!-- end of sidebar -->

    <!-- start of appbar -->
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="primary"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span class="hidden-sm-and-down">Softplus POS</span>
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon>
        <v-icon>mdi-apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>mdi-bell</v-icon>
      </v-btn>
      <v-btn text color="white" @click="logout">Logout</v-btn>
    </v-app-bar>
    <!-- end of appbar -->
  </section>
</template>

<script>
export default {
  computed: {
    items() {
      const role = localStorage.getItem("userRole");
      return this.myitems.filter((item) => {
        return item.role <= role;
      });
    },
  },
  data: () => ({
    drawer: true,
    myitems: [
      {
        icon: "mdi-contacts",
        text: "Dashboard",
        link: "/subscriber/dashboard",
        role: 2
      },
      { icon: "mdi-contacts", text: "POS", link: "/pos", role: 1 },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Purchasing",
        model: false,
        role: 2,
        children: [
          { icon: "mdi-save", text: "Purchase Order", link: "/purchase/order" },
          {
            icon: "mdi-save",
            text: "Goods Receipt PO",
            link: "/goods/receipt",
          },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Sales",
        model: false,
        role: 2,
        children: [
          { icon: "mdi-save", text: "Sales Order", link: "/sales/order" },
          {
            icon: "mdi-save",
            text: "Delivery",
            link: "/delivery",
          },
        ],
      },
      // {
      //   icon: "mdi-keyboard",
      //   text: "Clients Requests",
      //   link: "/client/requests",
      // },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Payments",
        model: false,
        role: 2,
        children: [
          { icon: "mdi-save", text: "Debtors", link: "/debtors" },
          {
            icon: "mdi-save",
            text: "Creditors",
            link: "/creditors",
          },
          // {
          //   icon: "mdi-save",
          //   text: "Advance Payments",
          //   link: "/advance/payments",
          // },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Expenses",
        model: false,
        role: 2,
        children: [
          { icon: "mdi-save", text: "Record Expenses", link: "/expenses" },
          {
            icon: "mdi-save",
            text: "Expenses Categories",
            link: "/expenses/categories",
          },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Products",
        role: 2,
        model: false,
        children: [
          { icon: "mdi-save", text: "Categories", link: "/product/categories" },
          { icon: "mdi-save", text: "Products List", link: "/products" },
          { icon: "mdi-save", text: "Import", link: "/products/import" },
        ],
      },
      {
        icon: "mdi-keyboard",
        text: "Customer Requests",
        link: "/customer-requests",
        role: 1
      },
      { icon: "mdi-keyboard", text: "Inventory", link: "/inventory", role: 2 },
      { icon: "mdi-settings", text: "Suppliers", link: "/suppliers", role: 2 },
      { icon: "mdi-message", text: "Customers", link: "/customers", role: 1 },
      { icon: "mdi-help-circle", text: "Accounts", link: "/accounts", role: 2 },
      { icon: "mdi-adobe", text: "Biz Classification", link: "/industries", role: 3 },
      { icon: "mdi-adobe", text: "Stores", link: "/stores", role: 3 },
      {
        icon: "mdi-message",
        text: "General Settings",
        link: "/general-settings",
        role: 3
      },
      // {
      //   icon: "mdi-tooltip-outline",
      //   text: "Sms Module",
      //   link: "/subscriber/sms",
      // },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Users Management",
        role: 2,
        model: false,
        children: [
          { icon: "mdi-save", text: "Users", link: "/users" },
          // {
          //   icon: "mdi-save",
          //   text: "Authorization",
          //   link: "/authorization",
          // },
        ],
      },
      {
        icon: "mdi-chevron-up",
        "icon-alt": "mdi-chevron-down",
        text: "Reports",
        role: 2,
        model: false,
        children: [
          { text: "Purchases", link: "/purchasing/reports" },
          { text: "Sales", link: "/sales/reports" },
          { text: "Payments", link: "/payment/report" },
          { text: "Expenses", link: "/expenditure/report" },
          { text: "PNL", link: "/pnl/report" },
          { text: "Stock Value", link: "/stockvalue/report" },
          { text: "Damaged Products", link: "/damaged/products" },
        ],
      },
    ],
  }),
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
/* .v-list-item {
  padding: 0px 0px 5px 10px !important;
} */
</style>

